export default __webpack_public_path__ + "static/media/balance-auto-turnoff.435ae77a.md";